import {Box} from '@mui/material';
import EStoreProductDetailAboutGameComponent from '@wearesection/bandai-react-components/organisms/EStoreProductDetailAboutGame';
import React, {ReactNode} from 'react';

type IProps = {
  description: ReactNode;
  dataTranslation?: any;
};

type IEStoreProductDetailAboutGameExt = {
  description: ReactNode;
  dataTranslation: any;
};

const adapter = (data: IProps) => {
  const description = (data?.description as string)?.split('</h2>');
  const propsAbout: any[] = [];

  description.map((item: string, idx: number) => {
    // Check existing h2
    if (item.includes('<h2>')) {
      // If index === 0 add to title else description
      if (item.indexOf('<h2>') === 0) {
        propsAbout[0] = {
          ...propsAbout[0],
          titleCompareEdition: item.replace(/<h2>/g, ''),
        };
      } else {
        // Not lied begin of the sentence
        const child = item.split('<h2>'); // Split to array

        // Add description into item previous
        propsAbout[idx - 1] = {
          ...propsAbout[idx - 1],
          gameShortDescription: {
            description: child[0],
          },
        };

        // Add title for next item
        propsAbout[idx] = {
          ...propsAbout[idx],
          titleCompareEdition: child[1],
        };
      }
    } else {
      // Add description
      propsAbout[idx - 1] = {
        ...propsAbout[idx - 1],
        description: item,
      };
    }
  });
  return propsAbout;
};

const EStoreProductDetailAboutGame: React.FC<IEStoreProductDetailAboutGameExt> = props => {
  const componentProps = adapter(props);

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: {
          xs: '48px',
          md: '40px',
        },
      }}
    >
      {componentProps.map((item: any, idx) => (
        <Box
          key={idx}
          sx={{
            paddingBottom: {
              xs: '24px',
              md: '34px',
            },
          }}
        >
          <EStoreProductDetailAboutGameComponent htmlRender {...item} />
        </Box>
      ))}
    </Box>
  );
};

export default EStoreProductDetailAboutGame;
